import React, {useEffect, useRef, useState} from 'react';
import throttle from 'lodash/throttle';

const useScrollDirection = (
    sliderContainerRef: React.MutableRefObject<HTMLDivElement>,
    headerRef?: React.MutableRefObject<HTMLDivElement>,
): {isDown: boolean; isUp: boolean; y: number; headerHeight: number} => {
    const headerHeight = headerRef?.current?.getBoundingClientRect()?.height || 50;
    const scrollPos = useRef(0);
    const [direction, setDirection] = useState({
        isDown: sliderContainerRef?.current?.getBoundingClientRect()?.top <= headerHeight || false,
        isUp: false,
        y: sliderContainerRef?.current?.getBoundingClientRect()?.top || headerHeight,
        headerHeight: headerHeight,
    });

    useEffect(() => {
        const handleScroll = throttle(() => {
            const positionY = sliderContainerRef?.current?.getBoundingClientRect()?.top ?? 0;

            setDirection({
                isDown:
                    positionY > headerHeight && positionY < scrollPos?.current ? false : positionY < scrollPos?.current,
                isUp: positionY > scrollPos?.current,
                y: positionY,
                headerHeight: headerHeight,
            });
            scrollPos.current = positionY;
        }, 100);

        window.addEventListener('scroll', handleScroll, {capture: true});
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return direction;
};

export default useScrollDirection;
